import global from "global";

const applicationOnlineStatusProvider = () => global.navigator.onLine;

export default applicationOnlineStatusProvider;
